import invert from "lodash/invert";
import uniqBy from "lodash/uniqBy";
import isEqual from "lodash/isEqual";

import {getFilterGroupValues, splitFeatureName} from "../../../misc/utils";
import DesignNavigationItem from "../../visComponents/designNavigationItem";
import {Part} from "./part";
import store from '../../../store';
import {
  LayoutAbbreviation, LayoutType, LayoutAbbreviationsToRemove, SIDE_POSITIONS,
  useNewNavLogicPartIds, LOOK_WALLS_ONLY, COUNTERTOP_GROUP_BATHROOM, PAN_POSITIONS, allShowerSideOptionsGroups
} from "./constants";
import {getFeatureIsLocked} from "../../../misc/helpers";
import {getOptionsFromNavItemsForFeature, navFeatureCLick} from "../lookNavigation/lookFunctions";
import {allowCheckForCollection} from "../grohe/groheNavigation/groheFunctions";
import {getDbFeatureProperty, getSkusDifferences, getSkuWithoutDot} from "../lookNavigation/lookFunctions2";
import {getColorFilterValue} from "../../../misc/filtersFunctions";
import {IS_LIXIL_SERVERS, IS_QKB_UI} from "../../../config";
import {HANDLES_GROUP_BATHROOM} from "../../bvSceneComponent/core/constants";
import {isEncore} from "../../../misc/fabricatorHardcode";

/**
 * Used for Complex parts such as Vanity, to perform some base functionality for related items
 */
export class IntermediatePart extends Part {

  constructor(isChild) {
    super(false, isChild);
    this.disabled = false;
    this.defaultDisabled = false; // used after reset click
    this.canBeDisabled = false;
  }

  /**
   * This will be called on feature creation
   * @param dbFeature
   */
  load(dbFeature) {
    if (this.layerPositions) {
      dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] && dbFeature.metaData["Side"][0] !== "0"
        ? dbFeature.metaData["Side"][0]
        : SIDE_POSITIONS[0];
      const partNumber = dbFeature.metaData["layerPosition"] === SIDE_POSITIONS[0] ? 1 : 2;
      const instance = new this.constructor(false, partNumber);
      return this.load_(dbFeature, instance, true, partNumber === 1 ? 'features' : 'featuresParts');
    }
    return this.load_(dbFeature, new this.constructor());
  }

  /**
   * This will be called by the underlying vanity feature with a concrete instance of the part
   * @param dbFeature
   * @param part {Part}
   * @param setParent {boolean}
   * @param features
   */
  load_(dbFeature, part, setParent = true, features = 'features') {

    const featureList = features + "List";

    const {displayName} = dbFeature;
    let {featureName} = splitFeatureName(displayName);
    if (!featureName && dbFeature.groupName && dbFeature.displayName) {
      featureName = dbFeature.displayName.replace(dbFeature.groupName + " - ", "")
    }
    // console.log('displayName:', displayName);

    if (setParent) {
      part.getParent = () => this;
      if (dbFeature.galleryImages) {
        const featured = dbFeature.galleryImages.find(galImage => galImage.featured);
        if (featured) {
          this.featuredImage = featured.url
        }
        dbFeature.galleryImages = dbFeature.galleryImages.sort((a, b) => b.default - a.default)
      }
    }

    if (!dbFeature.sharedFeatureName) {
      console.error("No sharedFeatureName property:", dbFeature);
      if (!dbFeature.displayName) {
        return false
      }
    }

    part.partName = featureName;
    part.metaData = dbFeature.metaData || {};

    if (dbFeature.s3Bindings && dbFeature.s3Bindings.length) {
      // dbFeature.s3Bindings = dbFeature.s3Bindings.filter(binding => binding.visualizer === "BathroomV5")
    }

    part.dbFeature = dbFeature || {};
    if (!part.dbFeature.filterValueIDs) {
      part.dbFeature.filterValueIDs = {}
    }
    part.notAvailableInVisualizer = !dbFeature.s3Bindings || !dbFeature.s3Bindings.length;

    if (part.metaData.RoomLayout) {
      const roomLayout = part.metaData.RoomLayout;
      if (roomLayout.includes(LayoutAbbreviation.All)) {
        Object.keys(LayoutType).forEach(layoutName => {
          this[featureList][layoutName].push(part);
        })
      } else if (Array.isArray(roomLayout) && roomLayout.length) {
        roomLayout.forEach(roomLayoutAbbreviation => {
          const layoutName = invert(LayoutAbbreviation)[roomLayoutAbbreviation];
          if (layoutName) { // Prevent bad roomLayout Metadata
            this[featureList][layoutName].push(part);
          }
        });
      } else {  // single value
        const layoutName = invert(LayoutAbbreviation)[roomLayout];
        if(layoutName) {
          this[featureList][layoutName].push(part);
        }
      }
    }

    if (part.notAvailableInVisualizer || !part.metaData.RoomLayout) {
      part.notAvailableInVisualizer = true;
      Object.keys(LayoutType).forEach(layoutName => {
        this[featureList][layoutName].push(part);
      })
    }

    // Object.keys(LayoutType).forEach(layoutName => {
    //   this[features+"List"][layoutName].push(part);
    // });

    this.loadFeatureCommon(part);

    return part
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions()
  }

  // someFeatureInStock(feature, arrayOfFeatures) {
  //   // console.log("someFeatureInStock", feature);
  //   return isInStock(feature) || arrayOfFeatures.some(currentFeature => {
  //     // if ((feature._collectionName === currentFeature._collectionName) && (currentFeature.dbFeature.id !== feature.dbFeature.id) && isInStock(currentFeature)) {
  //     //   console.log("currentFeature", currentFeature);
  //     // }
  //     if (feature.partId === "vanity_sink") {
  //       return (feature._collectionName === currentFeature._collectionName)
  //         && (currentFeature.dbFeature.id !== feature.dbFeature.id) && isInStock(currentFeature)
  //     }
  //     return (feature._collectionName === currentFeature._collectionName)
  //       && (feature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] === currentFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")])
  //       && (currentFeature.dbFeature.id !== feature.dbFeature.id) && isInStock(currentFeature)
  //   })
  // }

  // navigationSubItems(filters, searchText, forFeature, filterGroups, restOptions) { // to do
  navigationSubItemsSimple(filters, searchText) {
    const featuresList = this.activeFeature && this.activeFeature.metaData.layerPosition
    && this.activeFeature.metaData.layerPosition !== SIDE_POSITIONS[0] ? this.featuresParts : this.features;
    const filteredAvailableFeatures = this.getFeaturesBySearchText(this.getFilteredFeaturesByFilters(filters, featuresList), searchText);
    let featuresToDisplay = this.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    // console.log("filterGroups", filterGroups);
    return this.returnUniqueNavFeatures(featuresToDisplay)
  }

  navigationSubItems(filters, searchText, forFeature, filterGroups, restOptions = {}) {
    // const {firstOpenedFeature, firstOpenedConditions, returnAllFeatures} = restOptions;
    const {returnAllFeatures} = restOptions;
    const featuresList = this.getFeaturesForNavigationFrom(restOptions);
    const filteredAvailableFeatures = this.getFeaturesBySearchText(this.getFilteredFeaturesByFilters(filters, featuresList), searchText);
    let featuresToDisplay = returnAllFeatures
      ? filteredAvailableFeatures
      : this.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    if (this.partId === "vanity_faucet" || HANDLES_GROUP_BATHROOM.includes(this.partId) || this.nextFeaturesPageToLoadArray) {
      const allConditions = this.getArrayOfConditions();
      if (this.partId === "vanity_faucet") {
        const mountTypeCondition = allConditions.find(cond => cond.propName === "MountType");
        if (mountTypeCondition) {
          featuresToDisplay = featuresToDisplay.sort((a, b) => {
            return b.matchesMetaForCondition(mountTypeCondition.propName, mountTypeCondition.propValue)
              - a.matchesMetaForCondition(mountTypeCondition.propName, mountTypeCondition.propValue)
          })
        }
      } else { // vanity_backsplash and vanity_countertop should show in visualizer first
        featuresToDisplay = featuresToDisplay.sort((a, b) => {
          return b.matchesMetaForArrayOfConditions(allConditions) - a.matchesMetaForArrayOfConditions(allConditions)
        })
      }
    }
    // console.log("filterGroups", filterGroups);
    if (this.layerPositions || this.oneLayerPosition || returnAllFeatures) {
      featuresToDisplay = uniqBy(featuresToDisplay, (feature) => feature.getSplittedFeatureName());
    }
    return this.navigationItemsWithOptions(filters, forFeature, filterGroups, featuresToDisplay, restOptions)
  }

  // navigationSubItems(filters, searchText, forFeature, filterGroups, restOptions) { // to do
  navigationItemsWithOptions(filters, forFeature, filterGroups, featuresToDisplay, restOptions = {}) {
    let newFeatures = [];
    let navItems = [];
    const matchingFeatureProperty = this.useMatchingFeatureReplacement || "MatchingFeature";
    const useSpecificVanityLogic = useNewNavLogicPartIds.includes(this.partId) && !restOptions.returnAllFeatures;

    if (filterGroups && filterGroups.length
      && (!filters || !Object.keys(filters).length || restOptions.returnAllFeatures)
      && !IS_QKB_UI && !isEncore) {
      // console.log("filteredAvailableFeatures", filteredAvailableFeatures);
      // console.log("featuresToDisplay", featuresToDisplay);
      for (let i = 0; i < featuresToDisplay.length; i++) { // 1) take all others
        const currentFeature = featuresToDisplay[i];
        // if (currentFeature.dbFeature.sharedFeatureName === "26128EN2") {
        //   debugger;//eslint-disable-line
        // }
        const collectionName = currentFeature.getCollectionName(filterGroups);
        const colorName = currentFeature.getColorName(filterGroups);
        const matchingOptionsName = currentFeature.getMatchingOptionsName();
        const matchByCollection = allowCheckForCollection(currentFeature) ? !newFeatures.some(feature => {
          return feature._collectionName === collectionName && feature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] === currentFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")]
        }) : false;
        let conditionPassed = false;
        if (useSpecificVanityLogic) {
          const sku = getSkuWithoutDot(currentFeature.dbFeature.sharedFeatureName);
          conditionPassed = !collectionName
            || matchByCollection
            || (!colorName && !newFeatures.some(feature => getSkusDifferences(feature.dbFeature.sharedFeatureName, currentFeature.dbFeature.sharedFeatureName) <= 1))
            || (colorName && !newFeatures.some(feature => {
              const skuDiff = getSkusDifferences(feature.dbFeature.sharedFeatureName, currentFeature.dbFeature.sharedFeatureName);
              if (this.partId === "vanity_cabinet" && skuDiff <= 2) {
                // case when K-33554-ASB-1WT and K-33555-ASB-0 and K-33555-ASB-1WT should be shown separately
                return false
              }
              return skuDiff <= 1 || getSkuWithoutDot(feature.dbFeature.sharedFeatureName) === sku
            }))
        } else {
          conditionPassed = !collectionName
            || !colorName
            || matchByCollection
            || !newFeatures.some(feature => feature.getColorName() && (feature.getMatchingOptionsName() === matchingOptionsName))
            || !newFeatures.some(feature => feature.metaData[matchingFeatureProperty] && currentFeature.metaData[matchingFeatureProperty]
              && isEqual(feature.metaData[matchingFeatureProperty], currentFeature.metaData[matchingFeatureProperty]))
        }
        if (conditionPassed) {
          newFeatures.push(currentFeature);
        }
      }
      // console.log("newFeatures", newFeatures);
      const navItemsWithOptions = this.getNavItemsWithOptions(
        forFeature,
        newFeatures,
        featuresToDisplay,
        filterGroups,
        useSpecificVanityLogic,
      );
      navItems = this.returnUniqueNavFeatures(navItemsWithOptions.map(featureObject => {
        return new DesignNavigationItem(featureObject.mainFeature.featureName, featureObject.mainFeature, featureObject.otherOptions)
      }), false);
    }
    if (!navItems.length) {
      navItems = this.returnUniqueNavFeatures(featuresToDisplay)
    }
    if (this.filterNavigationItems && forFeature) {
      navItems = this.filterNavigationItems(navItems, forFeature)
    }
    // console.log("navItems", navItems);
    return navItems
  }

  /**
   * this is almost the same as feature options, it is replacing next nav items with the needed color feature
   * @param forFeature {featureInterface} featureInterface
   * @param newFeatures {[featureInterface]}
   * @param allFeatures {[featureInterface]}
   * @param filterGroups {[filterGroupInterface]}
   * @param useSpecificVanityLogic {boolean}
   * @returns {array}
   */
  getNavItemsWithOptions = (forFeature= null,
                            newFeatures = [],
                            allFeatures = [],
                            filterGroups,
                            useSpecificVanityLogic = false) => {

    const matchingFeatureProperty = this.useMatchingFeatureReplacement || "MatchingFeature";
    const neededColorName = forFeature ? forFeature.getColorName(filterGroups) : "";

    return newFeatures.map(currentFeature => {
      const filterValue = getColorFilterValue(currentFeature, filterGroups);
      const otherOptions = getOptionsFromNavItemsForFeature(currentFeature, allFeatures, filterGroups);

      const currentFeatureColor = currentFeature.getColorName(filterGroups);
      const customFullDisplayName = currentFeature.getMatchingOptionsName();
      const matchByCollection = forFeature && allowCheckForCollection(currentFeature) ? (currentFeature._collectionName === forFeature._collectionName) : true;
      let matchForSimilarSku = forFeature && useSpecificVanityLogic && matchByCollection
          && getSkusDifferences(currentFeature.dbFeature.sharedFeatureName, forFeature.dbFeature.sharedFeatureName) <= 1;
      if (this.partId === "vanity_cabinet" && matchForSimilarSku) {
          matchForSimilarSku = customFullDisplayName === forFeature.getMatchingOptionsName() // cases when 48 replaced 24
      }
      if (forFeature && (currentFeature.dbFeature.id === forFeature.dbFeature.id || matchForSimilarSku || (
          (customFullDisplayName === forFeature.getMatchingOptionsName())
          && (!forFeature.metaData[matchingFeatureProperty] || isEqual(forFeature.metaData[matchingFeatureProperty], currentFeature.metaData[matchingFeatureProperty]))
          && matchByCollection
          && (forFeature.partId === "vanity_sink" ? true : forFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] === currentFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")])
          && (currentFeature.dbFeature.id !== forFeature.dbFeature.id)
          && (currentFeatureColor && forFeature.getColorName(filterGroups) && (currentFeatureColor !== forFeature.getColorName(filterGroups)))
      ))) {
        if (filterValue && !otherOptions.some(option => option.colorValue.id === filterValue.id)) {
          otherOptions.push({feature: currentFeature, colorValue: filterValue})
        }
        return {
          mainFeature: forFeature,
          otherOptions: otherOptions.filter(option => option.feature.dbFeature.id !== forFeature.dbFeature.id)
        };
      } else {
        // console.log("neededColorName", neededColorName);
        // console.log("otherOptions", otherOptions);
        if (!filterValue || !otherOptions.length) {
          return {mainFeature: currentFeature, otherOptions: []}
        }
        if (!LOOK_WALLS_ONLY.includes(this.partId) && !COUNTERTOP_GROUP_BATHROOM.includes(this.partId)) {
          const allOptions = [{feature: currentFeature, colorValue: filterValue}, ...otherOptions];
          const mainOption = (forFeature && neededColorName && allOptions.find(option => option.feature.getColorName(filterGroups) === neededColorName))
            || allOptions.find(option => option.feature.getColorName(filterGroups) && option.feature.getColorName(filterGroups).includes("Chrome"))
            || allOptions.find(option => option.feature.getColorName(filterGroups) && option.feature.getColorName(filterGroups).includes("White"))
            || allOptions.find(option => option.feature.getColorName(filterGroups) && option.feature.getColorName(filterGroups).includes("rushed")) // brushed nickel;
          // console.log("mainOption", mainOption);
          if (mainOption) {
            return {
              mainFeature: mainOption.feature,
              otherOptions: allOptions.filter(option => option.feature.dbFeature.id !== mainOption.feature.dbFeature.id)
            }
          }
        }
        return {mainFeature: currentFeature, otherOptions}
      }
    });
  }



  navigationSubItemsWithSides(filters, searchText) {
    const filteredAvailableFeatures = this.getFeaturesBySearchText(this.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = this.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);

    let navFeatures = [];
    const activePosition = this.activeFeature && this.activeFeature.dbFeature.metaData["layerPosition"]
      ? this.activeFeature.dbFeature.metaData["layerPosition"]
      : SIDE_POSITIONS[0];
    navFeatures = featuresToDisplay.filter(feature => {
      return feature.dbFeature.metaData["layerPosition"] === activePosition
    })
    featuresToDisplay.forEach(feature => {
      const name1 = feature.getSplittedFeatureName();
      if (!navFeatures.some(navFeature => navFeature.getSplittedFeatureName() === name1)) {
        navFeatures.push(feature)
      }
    })
    return this.returnUniqueNavFeatures(navFeatures)
  }

  navigationSubItemsWithFilter(propName, propValue, featuresToCheck = this.features) {
    return featuresToCheck.filter((feature) => {
      return feature.matchesMetaForCondition(propName, propValue);
    }).map(_ => new DesignNavigationItem(_.featureName, _));
  }

  navigationSubItemsWithFilterMultipleConditions(arrayOfConditions, featuresToCheck = this.features) {
    // console.log('arrayOfConditions', arrayOfConditions);
    // console.log('featuresToCheck', featuresToCheck);
    return featuresToCheck.filter((feature) => {
      return feature.notAvailableInVisualizer || arrayOfConditions.every((conditionObject) => {
        const {propName, propValue} = conditionObject;
        return feature.matchesMetaForCondition(propName, propValue);
      });
    })
  }

  setDefault(layout, setNotInVisFeature = false) {
    this.setFeatureGroupDefault(layout, setNotInVisFeature)
  }

  setLayerPositions = (activeFeature = this.activeFeature) => {
    if (!activeFeature) {
      return
    }
    const layout = this.getParent().layout;
    const conditions = this.getArrayOfConditions();
    if (layout && this.defaultLayerLayoutPositions && this.defaultLayerLayoutPositions[layout.type]) {
      Object.keys(this.layerPositions).forEach(key => {
        if (this.defaultLayerLayoutPositions[layout.type] === key
          && (!this.layerPositions[key] || !this.layerPositions[key].matchesMetaForArrayOfConditions(conditions))) {
          this.layerPositions[key] = activeFeature;
        } else if (activeFeature.dbFeature.metaData["layerPosition"] !== key) {
          this.layerPositions[key] = null;
        }
      })
    } else if (allShowerSideOptionsGroups.includes(this.partId) && Object.keys(this.layerPositions).some(key => this.layerPositions[key])) {
      Object.keys(this.layerPositions).forEach(key => {
        if (this.layerPositions[key]) { // do not turn on new positions. only change existing
          const matchingPositionFeature = this.getMatchingPositionFeature(key);
          if (matchingPositionFeature) {
            this.layerPositions[key] = matchingPositionFeature;
          }
        }
      })
    } else {
      Object.keys(this.layerPositions).forEach(key => {
        if ((activeFeature.dbFeature.metaData["layerPosition"] === key)
          && (!this.layerPositions[key] || !this.layerPositions[key].matchesMetaForArrayOfConditions(conditions))) {
          this.layerPositions[key] = activeFeature;
          // } else if (this.setAllLayerPositions) {
        } else if ((key !== "C" && activeFeature.metaData.layerPosition === "C") || (activeFeature.metaData.layerPosition !== "C" && key === "C")) {
          this.layerPositions[key] = null;
        } else {
          const matchingPositionFeature = this.getMatchingPositionFeature(key);
          if (matchingPositionFeature) {
            this.layerPositions[key] = matchingPositionFeature;
          }
        }
      })
    }
  }

  toggleLayerPositions() {
    if (this.layerPositions) { // just in case
      Object.keys(this.layerPositions).forEach(key => {
        this.layerPositions[key] = this.disabled ? null : this.getMatchingPositionFeature(key)
      })
    }
  }

  getMatchingPositionFeature = (position = "",
                                fromFeature = this.activeFeature,
                                fromLayout = null,
                                conditions = null) => {
    if (fromFeature) { //just in case
      const name1 = fromFeature.getSplittedFeatureName();
      let arrayOfConditions = (conditions || this.getArrayOfConditions()).filter(cond => cond.propName !== "Side");
      // if (fromFeature.metaData["SkuName"]) {
      //   arrayOfConditions.push({
      //     propName: "SkuName",
      //     propValue: fromFeature.metaData["SkuName"]
      //   })
      // }
      if (fromLayout) {
        let roomLayoutMeta = arrayOfConditions.find(condition => condition.propName === "RoomLayout");
        let roomSceneMeta = arrayOfConditions.find(condition => condition.propName === "RoomScene");
        if (roomLayoutMeta) {
          roomLayoutMeta.propValue = fromLayout.getCurrentLayoutAbbreviation();
        }
        if (roomSceneMeta) {
          roomSceneMeta.propValue = fromLayout.scene;
        }
      }

      const whereToFind = (!this.layerPositions || (position === Object.keys(this.layerPositions)[0])
        || (this.partId === "grab_bar" && position === "C"))
        ? fromLayout ? this.featuresList[fromLayout.getCurrentLayoutName()] : this.features
        : fromLayout ? this.featuresPartsList[fromLayout.getCurrentLayoutName()] : this.featuresParts;

      let matchFeature = null;
      if (fromFeature.metaData["SkuName"]) {
        const withSkuNameConditions = [...arrayOfConditions, {
          propName: "SkuName",
          propValue: fromFeature.metaData["SkuName"][0],
        }]
        matchFeature = whereToFind.find((feature) => {
          return name1 === feature.getSplittedFeatureName()
              && feature.matchesMetaForArrayOfConditions(withSkuNameConditions) && feature.metaData["layerPosition"] === position
        });
      }
      if (!matchFeature) {
        matchFeature = whereToFind.find((feature) => {
          return name1 === feature.getSplittedFeatureName()
              && feature.matchesMetaForArrayOfConditions(arrayOfConditions) && feature.metaData["layerPosition"] === position
        });
      }
      return matchFeature
    }
    return null
  };

  getArrayOfConditions() {
    const layout = this.getParent().layout;
    return [{
      propName: 'RoomLayout',
      propValue: layout.getCurrentLayoutAbbreviation()
    }, {
      propName: 'RoomScene',
      propValue: layout.scene
    }];
  }

  setLayers(layout) {
    if (this.hideLayerCondition && this.hideLayerCondition()) {
      this.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      if (this.hasAdditionalParts) {
        this.checkIfFeaturePartIsMatching();
      }
      return this._setLayers(layout);
    }
    this.setDefault(layout);
    return this._setLayers(layout);
  }

  showLayerPositionsModal(forFeature) {
    const checkSidesFeatureGroups = ["shower_door", "shower_fixture", "grab_bar", "large_corner_seat",
      "replacement_tub", "shower_pan_combo", "corner_caddie", "large_corner_caddie", "soap_dish", "walk_in_tub",
      "shower_seats", "replacement_tub_fixture"];
    if (checkSidesFeatureGroups.includes(this.partId)) {
      const positionsAvailable = PAN_POSITIONS.filter(position => {
        return !!this.getMatchingPositionFeature(position, forFeature);
      });
      return positionsAvailable.length > 1
    }
    return false
  }

  clickFromAllWalls(ignoreLocked) {
    if (this && this.dbFeature && this.dbFeature.sharedFeatureName) {
      console.log(`${this.partId}:`, this.dbFeature.sharedFeatureName);
    }
    navFeatureCLick(this, false, ignoreLocked, false);
    // this.handleClick(ignoreLocked, "all_walls");
  }

  /**
   * @param ignoreLocked {boolean}  // false by the default, is used by wizard ONLY
   */
  handleClick(ignoreLocked = false) {
    const parent = this.getParent();
    const {activeQuoteIndex} = store.getState().quotesState;
    parent.firstClick[activeQuoteIndex] = true; // allow to show active item
    const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
    if (featureIsLocked) {
      parent.activeLockedFeature = this;
    } else {
      if (parent.activeLockedFeature) {
        parent.activeLockedFeature = null;
      }
      this.featureClick();
    }
  }

  featureClick() {
    const parent = this.getParent();
    parent.placeholderChanged = true;
    if (this.notAvailableInVisualizer) {
      parent.activeNotInVisualizerFeature = this; // do not change the activeFeature (in order to keep the layer)
    } else if (parent.activeNotInVisualizerFeature) {
      parent.activeNotInVisualizerFeature = null; // remove it from other searches and so on
      parent.activeFeature = this;
    } else {
      parent.activeFeature = this;
    }
    this.featureClicked();
  }

  hideLayers() {
    if (this.activeFeature) {
      this.activeFeature.layer.src = '';
    }
    if (Array.isArray(this.activeFeatureParts) && this.activeFeatureParts.length) {
      this.activeFeatureParts.forEach((activeFeaturePart) => {
        if (activeFeaturePart && activeFeaturePart.layer) {
          activeFeaturePart.layer.src = '';
        }
      })
    }
    if (this.placeholderFeature) {
      this.placeholderFeature.layer.src = '';
    }
    if (this.layerPositions) {
      Object.keys(this.layerPositions).forEach(key => {
        if (this.layerPositions[key]) {
          this.layerPositions[key].layer.src = '';
        }
      })
    }
  }

  setZIndex(zIndexes) {

    const getZIndex = (feature, partId = null) => {
      return feature.metaData["ZSorting"] ? feature.metaData["ZSorting"] * 1000 : zIndexes[partId || this.partId];
    }

    let increase = 0;
    if (this.layerPositions) {
      Object.keys(this.layerPositions).forEach((key) => {
        const feature = this.layerPositions[key];
        if (feature) {
          increase = increase + 0.000001;
          feature.layer.zIndex = getZIndex(feature) + increase;
        }
      })
    } else if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = getZIndex(this.activeFeature);
      if (this.hasAdditionalParts && this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if (this.partId === "attachment") {
            activeFeaturePart.layer.zIndex = getZIndex(activeFeaturePart, this.additionalPartPartId)
          } else {
            increase = increase + 0.000001;
            activeFeaturePart.layer.zIndex = getZIndex(activeFeaturePart, this.additionalPartPartId) + increase;
          }
        });
      }
    }
  }

  removeLayoutFromPartName(partName) {
    LayoutAbbreviationsToRemove.forEach(abbr => {
      const spaceWithLayoutName = " "+abbr;
      partName = partName.replace(spaceWithLayoutName + " ", " "); // 1) replace " Agra S Some edge name" -> " Agra Some edge name"
      if (partName.slice(-spaceWithLayoutName.length) === spaceWithLayoutName) {
        partName = partName.substring(0, partName.length - spaceWithLayoutName.length); // 2) replace " Agra Some edge name S" -> " Agra Some edge name"
      }
    });
    partName = partName.replace(" Backsplash", "");
    return partName
  }

  removeEdgeFromPartName(partName) {
    const filterGroups = store.getState().filterState.filterGroups;
    const edgeFilterGroup = filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
    if (edgeFilterGroup && edgeFilterGroup.values && edgeFilterGroup.values.length) {
      const edgeFilterGroupValues = edgeFilterGroup.values.sort((a,b) => {
        return a.value && b.value && (b.value.length - a.value.length)
      }); // 1st should be "Full Bullnose", then simple "Bullnose"
      edgeFilterGroupValues.forEach((filterGroupValue) => { // arrayOf {id: 293, value: "Eased", displayText: "Eased", parent_id: null, icon: "", …}
        partName = partName.split(" "+filterGroupValue.value).join("");
      });
    }
    return partName
  }

  getCountertopGroupsSplittedFeatureName = () => {
    if (this._countertopGroupsCustomDisplayName == null) {
      this._countertopGroupsCustomDisplayName = this.dbFeature.sharedFeatureName || "";
    }
    return this._countertopGroupsCustomDisplayName
  };

  getSplittedFeatureName = () => {
    if (this._customDisplayName == null || this.dbFeature.wasUpdatedFromAnotherResponse) {
      this._customDisplayName = this.dbFeature.sharedFeatureName || this.partName || "";
      if (LOOK_WALLS_ONLY.includes(this.partId) || COUNTERTOP_GROUP_BATHROOM.includes(this.partId)) {
        const manufacturerFilter = getFilterGroupValues(this, {id: 35});
        if (Array.isArray(manufacturerFilter)) {
          this._customDisplayName = this._customDisplayName + manufacturerFilter[0];
        }
      } else if (this.partId === "shower_pan_combo") {
        this._customDisplayName = !IS_LIXIL_SERVERS && this.metaData && Array.isArray(this.metaData["MatchingFeature"])
        && this.metaData["MatchingFeature"][0]
          ? this.metaData["MatchingFeature"][0]
          : this._customDisplayName.replace(/LHO/g, "").replace(/RHO/g, "");
      }
    }
    if (this.dbFeature.wasUpdatedFromAnotherResponse) {
      this.dbFeature.wasUpdatedFromAnotherResponse = false;
    }
    return this._customDisplayName
  };

  getMatchingOptionsName = () => {
    if (!this._customMatchingOptionsName) {
      switch (this.partId) {
        case "vanity_cabinet":
          this._customMatchingOptionsName = getSkuWithoutDot(this.getCustomFullDisplayName()).split("-ASB")[0];
          break;
        case "hand_shower_only": {
          this._customMatchingOptionsName = this.getCustomFullDisplayName();
          if (this.metaData["MatchingFeature"] && this.metaData["MatchingFeature"][0]) {
            this._customMatchingOptionsName += this.metaData["MatchingFeature"][0];
          }
          break;
        }
        case "vanity_backsplash":
        case "vanity_countertop":
        case "walk_in_tub_fixture":
          this._customMatchingOptionsName = this.getSplittedFeatureName();
          break;
        // case "shower_fixture":
        // case "shower_door":
        // case "vanity_sink":
        // case "vanity_console":
        //   this._customMatchingOptionsName = getSkuWithoutDot(this.getSplittedFeatureName()); // TU105507.243 -> TU105507
        //   break;
        // case "body_spray":
        // case "hand_shower_holder":
        //   this._customMatchingOptionsName = this.getSplittedFeatureName().substr(0, 5);
        //   break;
        default:
          if (!this.isFromAsRoom && !this.notAvailableInVisualizer) { // grohe 26128002 should match with 26128EN2
            this._customMatchingOptionsName = this.getSplittedFeatureName().substr(0, 5);
          } else {
            this._customMatchingOptionsName = getSkuWithoutDot(this.getSplittedFeatureName());  // TU105507.243 -> TU105507
          }
          break;
      }
      if (LOOK_WALLS_ONLY.includes(this.partId)) {
        const manufacturerFilter = getFilterGroupValues(this, {id: 35});
        if (Array.isArray(manufacturerFilter)) {
          this._customMatchingOptionsName = this._customMatchingOptionsName + manufacturerFilter[0];
        }
      }
    }
    return this._customMatchingOptionsName
  };

  getSplittedSku = () => {
    if (!this._splittedSku) {
      this._splittedSku = this.dbFeature.isFromAsRoom
        ? getSkuWithoutDot(this.dbFeature.sku || this.dbFeature.sharedFeatureName || "") // as rooms should have 8
        : (this.dbFeature.sku || this.dbFeature.sharedFeatureName || "").substr(0, 5); // grohe rooms should have 5
    }
    return this._splittedSku
  }

  getMatchingFeatureName = () => {
    return this.getSplittedFeatureName()
  };

  getCustomFullDisplayName = () => {
    if (!this._customFullDisplayName) {
      this._customFullDisplayName = this.dbFeature.customDisplayName || "";
      switch (this.partId) {
        case "vanity_faucet":
          this._customFullDisplayName = this._customFullDisplayName
            .replace(" With Lever Handles", "")
            .replace(" With Lever Handle", "");
          break;
        case "vanity_sink":
          this._customFullDisplayName = this._customFullDisplayName
            .replace("4 Inch Centerset ", "")
            .replace("8 Inch Widespread ", "")
            .replace("Center Hole Only ", "");
          break;
        case "shower_hose":
          this._customFullDisplayName = this._customFullDisplayName.replace(" Longlife", "")
          break;
        default:
          break;
      }
    }
    return this._customFullDisplayName
  };

  getModuleFeatureName = () => {
    // return this.partName.split(" M_")[0];
    return this.partName.split(" M")[0];
  };

  featureIsMatchingFilters(currentFeature, activeFilters, filters = []) {
    return filters.every(filter => {
        return activeFilters[filter.id]
          && currentFeature.dbFeature.filterValueIDs[filter.id]
          && currentFeature.dbFeature.filterValueIDs[filter.id].includes(activeFilters[filter.id][0])
      })
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      let activeFeaturePart;
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);
      // if (this.partId === "right_wall") {
      //   arrayOfConditions = arrayOfConditions.filter(condition => condition.propName !== "MirrorSize");
      // }
      if (this.getAdditionalPartsConditions) {
        arrayOfConditions = this.getAdditionalPartsConditions(arrayOfConditions); // modify or extend parts conditions
      }
      activeFeatureParts = this.featuresParts.filter((feature) => name1 === feature.getSplittedFeatureName());
      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      if (activeFeatureParts.length) {
        activeFeaturePart = activeFeatureParts.find((feature) => {
          return feature.matchesMetaForArrayOfConditions(arrayOfConditions)
        });
        if (!activeFeaturePart) {
          activeFeaturePart = activeFeatureParts[0];
        }
      }
      activeFeatureParts = activeFeaturePart ? [activeFeaturePart] : [];
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

  checkIfFeaturePartIsMatching() {
    if (this.activeFeatureParts && this.activeFeatureParts.length) {
      let activeFeatureConditions = this.getActiveFeatureConditions();
      if (this.getAdditionalPartsConditions) {
        activeFeatureConditions = this.getAdditionalPartsConditions(activeFeatureConditions); // modify or extend parts conditions
      }
      const name1 = this.activeFeature.getSplittedFeatureName();
      const activeFeaturePart = this.activeFeatureParts[0];
      if (!(activeFeaturePart.matchesMetaForArrayOfConditions(activeFeatureConditions)
        && name1 === activeFeaturePart.getSplittedFeatureName())) {
        this.activeFeatureParts = this.setActiveFeatureParts(this.activeFeature, activeFeatureConditions);
      }
    } else {
      this.activeFeatureParts = this.setActiveFeatureParts();
    }
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    if (!this.hasAdditionalParts) {
      return []
    }
    return this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
  }


  // OLD SHOWER LOGIC

  rememberPreviousSelection(shower, currentActiveFeature) {
    const layoutAbbr = shower.layout.getCurrentLayoutAbbreviation();
    const currentShowerBodyId = IntermediatePart.getCurrentShowerBodyId(shower);
    const wallConfiguration = shower.layout.parts["Shower Tub Combo"] && shower.layout.parts["Shower Tub Combo"].wallConfiguration;
    if (this.currentShowerBodyId !== currentShowerBodyId && currentActiveFeature && !currentActiveFeature.partName.includes("laceholder")) {
      if (!this.previouslySelectedFeatures[layoutAbbr]) {
        this.previouslySelectedFeatures[layoutAbbr] = {}
      }
      this.previouslySelectedFeatures[layoutAbbr][this.currentShowerBodyId] = currentActiveFeature; // remember previous active item
      if (wallConfiguration
        && wallConfiguration.features.some(feature => feature.showerBodyId === this.currentShowerBodyId)) {
        wallConfiguration.features.forEach((wallConfigurationFeature) => { // remember previous active item for all wall conf
          this.previouslySelectedFeatures[layoutAbbr][wallConfigurationFeature.showerBodyId] = currentActiveFeature;
        })
      }
    }
    this.currentShowerBodyId = currentShowerBodyId; // set new shower type
  }

  setDefaultAccordingToPreviousSelect(shower, filteredFeatures, hardCodedDefaultName, placeholderDefaultName = "laceholder") {
    const layoutAbbr = shower.layout.getCurrentLayoutAbbreviation();
    const currentShowerBodyId = IntermediatePart.getCurrentShowerBodyId(shower);
    // console.log('currentShowerBodyId', currentShowerBodyId);
    // console.log('this.previouslySelectedFeatures', this.previouslySelectedFeatures);

    if (this.currentShowerBodyId !== currentShowerBodyId
      && this.previouslySelectedFeatures[layoutAbbr]
      && this.previouslySelectedFeatures[layoutAbbr][currentShowerBodyId]
      && filteredFeatures.some(f => f.dbFeature.id === this.previouslySelectedFeatures[layoutAbbr][currentShowerBodyId].dbFeature.id)) {
      this.activeFeature = this.previouslySelectedFeatures[layoutAbbr][currentShowerBodyId]; // restore from previous chosen
    } else {
      const hardCodedDefault = hardCodedDefaultName && filteredFeatures.find((feature) => {
        return !feature.notAvailableInVisualizer && feature.dbFeature.displayName && feature.dbFeature.displayName.includes(hardCodedDefaultName);
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
    }
    const placeholderDefault = filteredFeatures.find((feature) => {
      return !feature.notAvailableInVisualizer && feature.dbFeature.displayName
        && feature.dbFeature.displayName.includes(placeholderDefaultName);
    });
    this.placeholderFeature = placeholderDefault || null;
  }

  canDisplayDemoPoint() {
    return true
  }

  /** shower door, fixture methods **/
  static getCurrentShowerBodyId(shower) {
    let currentShowerBodyId = "";
    const showerTubComboIsActive = shower.showerTubComboIsActive();
    if (!showerTubComboIsActive && shower.showerBody && shower.showerBody.activeFeature) {
      currentShowerBodyId = shower.showerBody.activeFeature.showerBodyId;
    } else if (showerTubComboIsActive && shower.layout.parts["Shower Tub Combo"]
      && shower.layout.parts["Shower Tub Combo"].wallConfiguration
      && shower.layout.parts["Shower Tub Combo"].wallConfiguration.activeFeature) {
      currentShowerBodyId = shower.layout.parts["Shower Tub Combo"].wallConfiguration.activeFeature.showerBodyId;
    }
    return currentShowerBodyId
  }

  canBeEnabled() {
    const {wizardActiveItem, wizardSelectedValues, wizardActiveStep} = store.getState().wizardState;
    if (wizardActiveItem && wizardActiveItem.hideItems && wizardActiveItem.wizardGroups
      && wizardActiveItem.wizardGroups.length
      && wizardActiveItem.wizardGroups.some(wizardGroup => wizardGroup.groupName === (this.dbName || this.partName))
      && !Object.keys(wizardSelectedValues).some(key => key <= wizardActiveStep && wizardSelectedValues[key].partId === this.partId)) {
      return false // do not enable feature group if it uses hide items (shower wizard issue)
    }
    return true
  }

  /**
   * @param position {string}
   * @param clickedFeature {featureInterface}
   * @returns {[featureInterface]}
   */
  checkConflictingPosition(position, clickedFeature) {
    if (!position || !clickedFeature || !this.conflictingPositions
      || ((clickedFeature.partId === "shower_seats")
        && !clickedFeature.dbFeature.sharedFeatureName.includes("Comfort Plus"))) { // hardcode - should be metadata here
      return []
    }
    const accParent = this.getParent();
    let conflictingPositions = [];
    this.conflictingPositions.forEach(partId => {
      const relItem = accParent.layout.getFeatureGroupByPartId(partId);
      if (relItem && !relItem.disabled && relItem.layerPositions && relItem.layerPositions[position]) {
        if ((clickedFeature.partId === "valve_trim")
          && !relItem.layerPositions[position].dbFeature.sharedFeatureName.includes("Comfort Plus")) {
          // hardcode - should be metadata here. for now only Comfort Plus are conflicting
          return
        }
        conflictingPositions.push(relItem.layerPositions[position])
      }
    });
    return conflictingPositions
  }

  applyConflictingPosition(position, clickedFeature) {
    const conflictingPositions = this.checkConflictingPosition(position, clickedFeature);
    conflictingPositions.forEach(feature => {
      const parent = feature.getParent();
      parent.layerPositions[position] = null;
    })
  }

}
